import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { GatsbyImage } from "gatsby-plugin-image";

export const HeroContentHubBase = styled.div`
  border-radius: 5px;
  display: grid;
  min-height: 133px;
  overflow: hidden;
  max-height: 395px;

  ${theme.largerThan.md} {
    max-height: 300px;
  }
`;

export const HeroImage = styled(GatsbyImage)`
  grid-area: 1/1;
`;

export const HeroContent = styled.div`
  grid-area: 1/1;
  display: flex;
  flex-direction: column;
  z-index: 1;
  padding: 72px 24px 36px;

  ${theme.largerThan.md} {
    padding: 60px 72px 114px;
  }
`;

export const HeroTitle = styled.h1`
  flex: 0 1 auto;
  color: #ffffff;
  margin-block-end: 8px;
`;

export const HeroDescription = styled.div`
  color: #ffffff;
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 73px;

  ${theme.largerThan.md} {
    font-size: 21px;
    line-height: 28px;
    margin-bottom: 36px;
  }
`;

export const NewsletterContainer = styled.div`
  ${theme.largerThan.md} {
    max-width: 550px;
  }
`;
